import { userIsSelfEmployed } from '../dataStructures/user/predicates';
import Job from './Job';
import JobSelfEmployed from './JobSelfEmployed';
import { useAuthentication } from '../authentication/authentication-hook';

export default function JobContainer({history, match}) {
  const { user } = useAuthentication();

  const isSelfEmployed = userIsSelfEmployed(user);

  if (isSelfEmployed) {
    return <JobSelfEmployed history={history} match={match}  />
  }

  return <Job history={history} match={match}  />
}
